import { apiService } from '../../../services/apiService';
import { getAcquirerRiskConfigPath } from '../../../utils/apiPaths';
import { fetchAcquirersGrid } from '../../acquirers/api/api';
import { EMPTY_ACQUIRER_COLUMN_FILTERS } from '../../acquirers/constants/constants';
import type { AcquirerRiskConfig, AcquirerRiskConfigRequest, AcquirerOption } from '../models/types';

function unwrap<T>(res: any, fallback: T): T {
  if (!res?.success) throw new Error(res?.message || 'Request failed.');
  return (res.data ?? fallback) as T;
}

/** Acquirer picker options. Reuses the acquirers grid fetcher rather than a bespoke endpoint, so the
 *  same list, statuses and soft-delete filtering the Acquirers page shows is what the picker shows. */
export async function fetchAcquirerOptions(): Promise<AcquirerOption[]> {
  const { rows } = await fetchAcquirersGrid({
    filterStatus: 'ALL',
    search: '',
    columnFilters: EMPTY_ACQUIRER_COLUMN_FILTERS,
  });
  return (rows as AcquirerOption[])
    .map((a) => ({ id: a.id, name: a.name, code: a.code }))
    .sort((x, y) => x.name.localeCompare(y.name));
}

export async function fetchAcquirerRiskConfig(acquirerId: number): Promise<AcquirerRiskConfig> {
  const res: any = await apiService.get(getAcquirerRiskConfigPath(acquirerId));
  return unwrap<AcquirerRiskConfig>(res, {
    acquirerId,
    acquirerName: '',
    configured: false,
    active: true,
    reviewScore: 40,
    blockScore: 70,
    rules: [],
  });
}

export async function saveAcquirerRiskConfig(
  acquirerId: number,
  payload: AcquirerRiskConfigRequest,
): Promise<AcquirerRiskConfig> {
  const res: any = await apiService.put(getAcquirerRiskConfigPath(acquirerId), payload);
  return unwrap<AcquirerRiskConfig>(res, {} as AcquirerRiskConfig);
}
